import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Col, Form, Input, Modal, Row, notification } from "antd";

export default function ModalPlacaVeiculo({ openModalPlaca, setOpenModalPlaca, formulario, dadosEditando }) {

    const validarPlaca = (placa) => {
        const placaConfirm = /^[A-Z]{3}[0-9]{4}$|^[A-Z]{3}[0-9]{1}[A-Z]{1}[0-9]{2}$/i;
        return placaConfirm.test(placa);
    };

    const onOk = () => {
        let placa = formulario.getFieldValue("orv_placa");

        if (!validarPlaca(placa)) {
            notification.warning({
                description: "Formato de placa inválido. Insira uma placa no formato AAA0000 ou AAA0A00.",
                message: "Atenção!"
            });
            formulario.setFieldsValue({ orv_placa: "" });
            return;
        }

        setOpenModalPlaca(false);
    };

    return (
        <Modal centered
            title={
                <span>
                    <ExclamationCircleOutlined style={{ marginRight: 8, color: "#faad14" }} />
                    Por favor, informe a Placa do Veículo
                </span>
            }
            open={openModalPlaca}
            onCancel={() => setOpenModalPlaca(false)}
            onOk={onOk}
        >
            <p>É obrigatório a informação da placa do veículo para continuar com o lançamento da OS.</p>
            <Form layout="vertical" name="manutencaoPedido" form={formulario}
                initialValues={{ orv_placa: dadosEditando?.orv_placa || "" }}>
                <Row>
                    <Col span={24}>
                        <Form.Item label="Placa do Veículo:" name="orv_placa">
                            <Input
                                placeholder="Informe a Placa do Veículo" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
